/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EmailChangePendingOldConfirmParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['status', /* #__PURE__ */ parsers.exactly('pending_old_confirm')],
]);
export class EmailChangePendingOldConfirm extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EmailChangePendingOldConfirmParser.decode(input).map(res => new EmailChangePendingOldConfirm(res));
    }
    static unsafeDecode(input) {
        return EmailChangePendingOldConfirm.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EmailChangePendingOldConfirmParser.encode(data);
    }
    static schema() {
        return EmailChangePendingOldConfirmParser.schema();
    }
}
